import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle, AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  const failedAttempts = ['Las apps de productividad a menudo se convierten en una distracción más para configurar.', 'El método Pomodoro es demasiado largo cuando el nivel de resistencia mental es alto.', 'Confiar en la "motivación" es un error, porque la motivación es un sentimiento que solo llega después de empezar a trabajar.', 'Los libros de 300 páginas sobre hábitos son demasiada teoría para alguien que necesita resultados ahora mismo.'];
  return <section className="py-24 bg-brand-card relative border-y border-white/5" data-id="element-129">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-130">
        <FadeIn data-id="element-131">
          <div className="flex items-center justify-center mb-6" data-id="element-132">
            <div className="w-16 h-16 rounded-2xl bg-red-500/10 flex items-center justify-center border border-red-500/20" data-id="element-133">
              <AlertTriangle className="text-red-500 w-8 h-8" data-id="element-134" />
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12" data-id="element-135">
            El Verdadero Problema
          </h2>
        </FadeIn>

        <div className="space-y-8 text-lg text-gray-300 leading-relaxed mb-16" data-id="element-136">
          <FadeIn delay={0.1} data-id="element-137">
            <p data-id="element-138">
              La mayoría de los emprendedores creen que el problema es la falta
              de disciplina. Intentan técnicas complejas de gestión de tiempo
              que requieren 25 o 50 minutos de enfoque total, pero cuando estás
              bloqueado, 25 minutos parecen una eternidad.
            </p>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-139">
            <p className="p-6 bg-brand-dark rounded-xl border border-white/5 shadow-inner" data-id="element-140">
              El verdadero problema es la{' '}
              <strong className="text-white" data-id="element-141">"fase de entrada"</strong>. Tu
              cerebro detecta la tarea importante como una amenaza y activa el
              modo de huida. Si no tienes un sistema para hackear esos primeros
              segundos, la procrastinación ganará siempre, dejándote con una
              sensación de culpa al final del día.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-142">
          <div className="bg-brand-darker rounded-2xl p-8 md:p-10 border border-red-500/10 relative overflow-hidden" data-id="element-143">
            <div className="absolute top-0 left-0 w-1 h-full bg-red-500/50" data-id="element-144" />
            <h3 className="text-2xl font-bold text-white mb-8" data-id="element-145">
              Por qué lo que intentaste no funcionó:
            </h3>
            <ul className="space-y-6" data-id="element-146">
              {failedAttempts.map((attempt, index) => <li key={index} className="flex items-start gap-4" data-id="element-147">
                  <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-148" />
                  <span className="text-gray-400 text-lg" data-id="element-149">{attempt}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}